/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

import IconElement from '../IconElement';

export default function HoursOfOperationModal(props) {
  const { iconAs, children } = props;
  return (
    <Modal
      className="hoo-modal"
      dimmer="inverted"
      trigger={
        iconAs === 'icon' ? (
          <button type="button" className="hoo-modal-trigger">
            <IconElement iconType="clock" element={<a>See Hours</a>} iconPosition="left" />
          </button>
        ) : (
          <Button icon="clock" secondary />
        )
      }
    >
      <Modal.Header>
        <div>Hours Of Operation</div>
      </Modal.Header>
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  );
}
